module.exports = __webpack_public_path__ + "static/media/underReviewIcon.9ba7fff9.svg";